/** A default Type classification for Cards within Folders SDK */
export var DefaultCardTypeNames;
(function (DefaultCardTypeNames) {
    /** Represents a collection of heterogeneous digital items. */
    DefaultCardTypeNames["Folder"] = "Folder";
    /** A MS Word document type. */
    DefaultCardTypeNames["Word"] = "WordDocument";
    /** A MS Excel document type. */
    DefaultCardTypeNames["Excel"] = "ExcelDocument";
    /** A MS PowerPoint document type. */
    DefaultCardTypeNames["PowerPoint"] = "PowerPointDocument";
})(DefaultCardTypeNames || (DefaultCardTypeNames = {}));
//# sourceMappingURL=foldersTypes.js.map